
window.addEventListener('load', function(){
  document.getElementById("nlMail").addEventListener("keydown", event=>{
    if(event.keyCode == 13) {
      event.preventDefault();
      document.querySelector("#newsletterForm #subscribe").click();
      return false;
    }
  });
  let formSelector = "#newsletterForm";
  let elems = {
    'nlMail': {'required': true, 'default': null},
    'nlPrivacy': {'required': true, 'default': null},
    'nlOtpStat': {'required': false, 'default': null},
    'nlOtpProfiling': {'required': false, 'default': null},
  }

  contactForm = new FormController(formSelector, elems, document.querySelector("#subscribe"), "https://contacts.moma.it/"+localeForm+"/mail.mngr",
  //contactForm = new FormController(formSelector, elems, document.querySelector("#subscribe"), "https://scdn.moma.it/salesforce/mailmgr.php",
    {
      successPopupId: 'newsletterConfirmed',
      initCallback: function(){
        let elem = this.formNode.querySelector("#nlMail");
        elem.addEventListener('input', e => {
          if(elem.value == ""){
            this.formNode.querySelector(".privacyContentBlock").classList.remove("show");
          }
          else{
            this.formNode.querySelector(".privacyContentBlock").classList.add("show");
          }
        })
      }
    }
  );
  
  let nlMail = document.getElementById("nlMail");
  let privacyContentBlock = document.querySelector("#newsletterForm .privacyContentBlock");
  
  if(nlMail != null && privacyContentBlock != null){
    nlMail.addEventListener("focus", e=>{
      privacyContentBlock.classList.add("show");
    });
    document.getElementById("nlMail").addEventListener("blur", e=>{
      if(nlMail.value == ""){
        privacyContentBlock.classList.remove("show");
      }
    });
  }
})
